











































































































import { Component, Vue } from 'vue-property-decorator'
import { Configuration, RedCapital, SelectedCountry, TitleTemplatePublic } from '@/configuration'

@Component({
	metaInfo: {
    title: 'Perfil de inversión',
    titleTemplate: TitleTemplatePublic,
    htmlAttrs: {
      // @ts-ignore
      lang: RedCapital[SelectedCountry].Lang,
    }
  },
	data() {
		return {
		}
	}
})

export default class GoodToKnow extends Vue {}
